import { render, staticRenderFns } from "./postMessage.vue?vue&type=template&id=1a19c92d&scoped=true&"
import script from "./postMessage.vue?vue&type=script&lang=js&"
export * from "./postMessage.vue?vue&type=script&lang=js&"
import style0 from "./postMessage.vue?vue&type=style&index=0&id=1a19c92d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a19c92d",
  null
  
)

export default component.exports